export type CamelToKebabCase<S extends string> = S extends `${infer P1}${infer P2}`
  ? `${P1 extends Uppercase<P1> ? `-${Lowercase<P1>}` : P1}${CamelToKebabCase<P2>}`
  : S;

export const camelToKebab = (str: string) => str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
